import { requestShareableLinkByReference } from "../services/chatService";
import { buildResourceReference, getResourceViewUrl } from "./resourceUtils";

export const openResourceView = async (resource, authToken) => {
  const directUrl = getResourceViewUrl(resource);
  if (directUrl) {
    window.open(directUrl, "_blank", "noopener,noreferrer");
    return;
  }

  if (!authToken) {
    throw new Error("Not authenticated");
  }

  const reference = buildResourceReference(resource);
  const { webUrl } = await requestShareableLinkByReference(reference, authToken);
  if (!webUrl) {
    throw new Error("Could not resolve file view URL");
  }
  window.open(webUrl, "_blank", "noopener,noreferrer");
};
